module.exports = __webpack_public_path__ + "static/media/6client.005e9a2d.png";